import {
  SET_UPLOADFORMPHD_PAGE2,
  CLEAR_UPLOADFORM_PAGE2,
  SET_UPLOADFORMPOSTDOC_PAGE2
} from "../action/types";

const initialState = {
  pagePhd: "",
  pagePostDoc: ""
};

export default function uploadFormReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_UPLOADFORMPHD_PAGE2:
      return { pagePhd: payload };

    case SET_UPLOADFORMPOSTDOC_PAGE2:
      return { pagePostDoc: payload };

    case CLEAR_UPLOADFORM_PAGE2:
      return { pagePhd: "", pagePostDoc: "" };

    default:
      return state;
  }
}
